var a = /* @__PURE__ */ ((e) => (e.StandardContent = "standard_content", e.RetailerAdaption = "retailer_adaption", e.SkuAdaption = "sku_adaption", e))(a || {});
const t = {
  INTERNAL_REVIEW: "internalReview",
  SETTINGS_PAGE: "settingsPage",
  CREATE_NEW_PROJECT: "createNewProject"
}, i = {
  ...t,
  // Nested featureFlags
  PDP_COPY_EDITING: "pdpCopyEditing",
  TASK_RESUBMISSION: "taskResubmission",
  CLIENTS_SETUP: "clientsSetup",
  BRANDS_SETUP: "brandsSetup",
  RETAILERS_SETUP: "retailersSetup",
  REGIONS_SETUP: "regionsSetup"
}, n = {
  clients: [
    {
      id: "c12345-abcd-6789-efgh-i98765jklmno",
      client_name: "L'Oréal Group",
      client_logo_url: "https://assets.example.com/logos/loreal-group.png",
      approval_required: {
        regional_standard_generation: !0,
        retailer_adaption: !0,
        sku_adaption: !1
      },
      update_info: {
        user_name: "Emma Wilson",
        comment: "Updated client logo and approval settings"
      },
      archived: !1,
      created_at: /* @__PURE__ */ new Date("2023-05-12T09:30:00.000Z"),
      updated_at: /* @__PURE__ */ new Date("2024-02-18T14:22:15.000Z"),
      brands: [
        {
          id: "loreal-paris",
          _id: "6662b9e1cf9a0d6d79c78cb1",
          client_id: "c12345-abcd-6789-efgh-i98765jklmno",
          brand_name: "L'Oréal Paris",
          version: 4,
          origin_id: "66621e9dd077d60f67579691",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Always emphasize the premium quality of L'Oréal Paris products",
                "Highlight the scientific research behind our formulations",
                "Use the tagline 'Because You're Worth It' where appropriate"
              ],
              guidelines_shortener: ["Keep the premium positioning in shortened content", "Maintain scientific credibility in brief descriptions"],
              restrictions: [
                "Never claim products are 'all natural' unless specifically true",
                "Avoid making direct comparisons to competitor brands",
                "Don't use the term 'anti-aging' without proper context"
              ],
              style_guide: {
                tone_of_voice: "Sophisticated, empowering, and scientifically credible",
                target_audience: "Women aged 25-65 who care about quality beauty products"
              }
            }
          },
          brand_keywords: {
            priority: ["premium", "scientific", "worth it"],
            required: ["L'Oréal Paris", "quality", "expert"],
            optional: ["innovative", "luxury", "advanced"],
            omit: ["cheap", "basic", "simple"],
            keyphrases_required: ["Because You're Worth It", "scientifically formulated"],
            keyphrases_optional: ["beauty expertise", "salon-quality results"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["loreal", "l'oreal"],
              replacement: "L'Oréal Paris"
            },
            {
              region: "66def0bcf0180e94af9bc452",
              patterns: ["because you're worth it", "because you are worth it"],
              replacement: "Because You're Worth It™"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 3,
            user_name: "Sophie Martin",
            comment: "Updated brand guidelines to align with global campaign"
          },
          created_at: /* @__PURE__ */ new Date("2023-05-15T10:30:22.301Z"),
          updated_at: /* @__PURE__ */ new Date("2024-01-20T11:45:33.301Z")
        },
        {
          id: "maybelline-new-york",
          _id: "6662b9e1cf9a0d6d79c78cb2",
          client_id: "c12345-abcd-6789-efgh-i98765jklmno",
          brand_name: "Maybelline New York",
          version: 3,
          origin_id: "66621e9dd077d60f67579692",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Focus on the urban, New York City inspiration",
                "Emphasize affordability without compromising quality",
                "Highlight the trendy and fashion-forward aspects of products"
              ],
              guidelines_shortener: ["Keep NYC references in shortened content", "Maintain the accessible fashion positioning"],
              restrictions: [
                "Don't position as a luxury or high-end brand",
                "Avoid using overly technical language",
                "Don't make claims about long-lasting wear unless specifically true for the product"
              ],
              style_guide: {
                tone_of_voice: "Trendy, energetic, and accessible",
                target_audience: "Fashion-conscious women aged 18-35"
              }
            }
          },
          brand_keywords: {
            priority: ["trendy", "affordable", "New York"],
            required: ["Maybelline", "makeup", "fashion"],
            optional: ["bold", "vibrant", "urban"],
            omit: ["expensive", "exclusive", "mature"],
            keyphrases_required: ["Make It Happen", "New York inspired"],
            keyphrases_optional: ["city-proof makeup", "runway to sidewalk"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["maybelline", "maybeline"],
              replacement: "Maybelline New York"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 2,
            user_name: "Jessica Taylor",
            comment: "Updated brand keywords to align with spring campaign"
          },
          created_at: /* @__PURE__ */ new Date("2023-06-10T14:22:45.301Z"),
          updated_at: /* @__PURE__ */ new Date("2024-02-05T09:30:12.301Z")
        }
      ]
    },
    {
      id: "c67890-wxyz-1234-mnop-q54321rstuvw",
      client_name: "Estée Lauder Companies",
      client_logo_url: "https://assets.example.com/logos/estee-lauder.png",
      approval_required: {
        regional_standard_generation: !0,
        retailer_adaption: !0,
        sku_adaption: !0
      },
      update_info: {
        user_name: "James Thompson",
        comment: "Initial client setup with strict approval requirements"
      },
      archived: !1,
      created_at: /* @__PURE__ */ new Date("2023-08-05T11:45:30.000Z"),
      updated_at: /* @__PURE__ */ new Date("2023-08-05T11:45:30.000Z"),
      brands: [
        {
          id: "estee-lauder",
          _id: "6662b9e1cf9a0d6d79c78cb3",
          client_id: "c67890-wxyz-1234-mnop-q54321rstuvw",
          brand_name: "Estée Lauder",
          version: 2,
          origin_id: "66621e9dd077d60f67579693",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Always emphasize the luxury and heritage of the brand",
                "Focus on the high-quality ingredients and scientific innovation",
                "Highlight the transformative effects of products"
              ],
              guidelines_shortener: ["Maintain luxury positioning in shortened content", "Keep references to scientific innovation"],
              restrictions: [
                "Never position as a mass-market brand",
                "Avoid casual or colloquial language",
                "Don't make exaggerated claims about immediate results"
              ],
              style_guide: {
                tone_of_voice: "Sophisticated, authoritative, and elegant",
                target_audience: "Discerning women aged 30+ who invest in premium skincare"
              }
            }
          },
          brand_keywords: {
            priority: ["luxury", "advanced", "transformative"],
            required: ["Estée Lauder", "premium", "results"],
            optional: ["radiant", "youthful", "refined"],
            omit: ["cheap", "budget", "basic"],
            keyphrases_required: ["beauty innovation", "scientific breakthrough"],
            keyphrases_optional: ["timeless beauty", "ageless elegance"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["estee lauder", "estée lauder"],
              replacement: "Estée Lauder"
            },
            {
              region: "66def0bcf0180e94af9bc452",
              patterns: ["anti-aging", "anti aging"],
              replacement: "age-defying"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 1,
            user_name: "Victoria Adams",
            comment: "Updated language guidelines for global consistency"
          },
          created_at: /* @__PURE__ */ new Date("2023-08-10T09:15:22.301Z"),
          updated_at: /* @__PURE__ */ new Date("2023-12-15T16:30:45.301Z")
        },
        {
          id: "clinique",
          _id: "6662b9e1cf9a0d6d79c78cb4",
          client_id: "c67890-wxyz-1234-mnop-q54321rstuvw",
          brand_name: "Clinique",
          version: 5,
          origin_id: "66621e9dd077d60f67579694",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Emphasize the dermatologist-developed approach",
                "Focus on simplicity, purity, and effectiveness",
                "Highlight the customized solutions for different skin types"
              ],
              guidelines_shortener: ["Maintain clinical positioning in shortened content", "Keep references to dermatologist development"],
              restrictions: [
                "Never use overly flowery or emotional language",
                "Avoid making claims about fragrances as products are fragrance-free",
                "Don't use the term 'natural' without proper context"
              ],
              style_guide: {
                tone_of_voice: "Clinical, straightforward, and trustworthy",
                target_audience: "Skincare-conscious consumers of all ages who value science-backed solutions"
              }
            }
          },
          brand_keywords: {
            priority: ["dermatologist", "allergy-tested", "effective"],
            required: ["Clinique", "simple", "custom-fit"],
            optional: ["pure", "gentle", "science"],
            omit: ["fragrance", "scented", "perfumed"],
            keyphrases_required: ["dermatologist-developed", "100% fragrance free"],
            keyphrases_optional: ["clinically proven", "custom-fit solutions"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["fragrance free", "fragrance-free"],
              replacement: "100% fragrance free"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 4,
            user_name: "Rachel Green",
            comment: "Updated clinical terminology based on dermatologist feedback"
          },
          created_at: /* @__PURE__ */ new Date("2023-08-12T11:20:15.301Z"),
          updated_at: /* @__PURE__ */ new Date("2024-03-01T10:45:22.301Z")
        }
      ]
    },
    {
      id: "c24680-fghi-3579-jklm-n13579opqrst",
      client_name: "Procter & Gamble Beauty",
      client_logo_url: "https://assets.example.com/logos/pg-beauty.png",
      approval_required: {
        regional_standard_generation: !1,
        retailer_adaption: !0,
        sku_adaption: !1
      },
      update_info: {
        user_name: "Sophia Martinez",
        comment: "Updated approval workflow to streamline content generation"
      },
      archived: !1,
      created_at: /* @__PURE__ */ new Date("2023-06-20T08:15:45.000Z"),
      updated_at: /* @__PURE__ */ new Date("2024-01-10T16:30:22.000Z"),
      brands: [
        {
          id: "olay",
          _id: "6662b9e1cf9a0d6d79c78cb5",
          client_id: "c24680-fghi-3579-jklm-n13579opqrst",
          brand_name: "Olay",
          version: 6,
          origin_id: "66621e9dd077d60f67579695",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Focus on the science-backed skincare solutions",
                "Emphasize visible results and transformation",
                "Highlight the accessibility of premium-quality skincare"
              ],
              guidelines_shortener: ["Keep references to scientific innovation", "Maintain focus on visible results"],
              restrictions: [
                "Avoid overly technical language that may confuse consumers",
                "Don't position as a luxury or exclusive brand",
                "Avoid making claims about immediate results unless specifically true"
              ],
              style_guide: {
                tone_of_voice: "Confident, approachable, and scientifically credible",
                target_audience: "Women aged 30-55 who want effective skincare without excessive cost"
              }
            }
          },
          brand_keywords: {
            priority: ["transformation", "science", "results"],
            required: ["Olay", "visible", "proven"],
            optional: ["radiant", "youthful", "ageless"],
            omit: ["expensive", "luxury", "exclusive"],
            keyphrases_required: ["visible results", "science-backed formulas"],
            keyphrases_optional: ["transformation in 28 days", "dermatologically tested"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["oil of olay"],
              replacement: "Olay"
            },
            {
              region: "66def0bcf0180e94af9bc452",
              patterns: ["anti-aging", "anti aging"],
              replacement: "age-defying"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 5,
            user_name: "Amanda Johnson",
            comment: "Updated brand positioning to align with new campaign focus"
          },
          created_at: /* @__PURE__ */ new Date("2023-06-25T13:40:22.301Z"),
          updated_at: /* @__PURE__ */ new Date("2024-02-10T09:15:33.301Z")
        },
        {
          id: "pantene",
          _id: "6662b9e1cf9a0d6d79c78cb6",
          client_id: "c24680-fghi-3579-jklm-n13579opqrst",
          brand_name: "Pantene",
          version: 4,
          origin_id: "66621e9dd077d60f67579696",
          archived: !1,
          config: {
            content_config: {
              guidelines: [
                "Focus on the Pro-V formula and its benefits",
                "Emphasize hair transformation and strength",
                "Highlight the salon-quality results at home"
              ],
              guidelines_shortener: ["Keep Pro-V references in shortened content", "Maintain focus on hair strength"],
              restrictions: [
                "Avoid making claims about permanent hair repair",
                "Don't use overly technical language about ingredients",
                "Avoid positioning as a treatment for medical hair conditions"
              ],
              style_guide: {
                tone_of_voice: "Confident, expert, and accessible",
                target_audience: "Men and women of all ages who want healthy, beautiful hair"
              }
            }
          },
          brand_keywords: {
            priority: ["Pro-V", "strength", "transformation"],
            required: ["Pantene", "healthy", "shine"],
            optional: ["smooth", "nourished", "protected"],
            omit: ["damaged", "broken", "brittle"],
            keyphrases_required: ["Pro-V formula", "strong is beautiful"],
            keyphrases_optional: ["salon-quality results", "hair transformation"]
          },
          brand_language: [
            {
              region: "66def0bcf0180e94af9bc451",
              patterns: ["pro v", "prov"],
              replacement: "Pro-V"
            }
          ],
          update_info: {
            type: "edit",
            from_version: 3,
            user_name: "Robert Chen",
            comment: "Updated brand keywords to emphasize strength messaging"
          },
          created_at: /* @__PURE__ */ new Date("2023-07-05T10:20:15.301Z"),
          updated_at: /* @__PURE__ */ new Date("2024-01-15T14:30:45.301Z")
        }
      ]
    }
  ]
}, r = {
  id: "999999-ffff-44444-9999-d951111c13f0",
  client_name: "L'Oréal",
  client_logo_url: "https://storage.googleapis.com/os-workspace-logos-ch-stage/5d8d619f-ff8c-4b14-86e7-b46493d038b9.PNG",
  archived: !1,
  created_at: "2023-11-15T08:02:59.301Z",
  updated_at: "2024-05-22T14:30:45.123Z",
  approval_required: {
    regional_standard_generation: !0,
    retailer_adaption: !1,
    sku_adaption: !0
  },
  update_info: {
    comment: "Updated client settings for Summer 2024 campaign",
    user_name: "Sarah Johnson"
  },
  brands: [
    {
      id: "maybelline-new-york",
      _id: "6662b9e1cf9a0d6d79c78cbe",
      brand_name: "Maybelline New York",
      client_id: "999999-ffff-44444-9999-d951111c13f0",
      archived: !1,
      origin_id: "66621e9dd077d60f67579693",
      version: 5,
      config: {
        content_config: {
          guidelines: [
            "Always emphasize the innovative technology behind products",
            "Use energetic and vibrant language",
            "Focus on the urban lifestyle aspect of the brand"
          ],
          guidelines_shortener: ["Maintain key product benefits", "Keep the same tone and style", "Prioritize unique selling points"],
          restrictions: ["Do not mention competitor brands", "Avoid making claims about permanent results", "Do not use medical terminology"],
          style_guide: {
            target_audience: "Women aged 18-35 who are beauty enthusiasts",
            tone_of_voice: "Bold, confident, and trendsetting"
          }
        }
      },
      brand_keywords: {
        priority: ["Trendsetting", "Bold", "Vibrant"],
        required: ["New York", "Makeup", "Beauty"],
        optional: ["Affordable", "Colorful", "Express yourself"],
        omit: ["Cheap", "Budget", "Low-quality"],
        keyphrases_required: ["Maybe it's Maybelline", "Make it happen"],
        keyphrases_optional: ["Express your urban style", "City-proof makeup"]
      },
      brand_language: [
        {
          region: "66def0bcf0180e94af9bc451",
          patterns: ["MAYBELLINE", "Maybelline New York"],
          replacement: "Maybelline NY"
        },
        {
          region: "66def0bcf0180e94af9bc452",
          patterns: ["MAYBELLINE"],
          replacement: "Maybelline New York"
        }
      ],
      update_info: {
        type: "edit",
        from_version: 4,
        user_name: "Michael Roberts",
        comment: "Updated brand guidelines for Q2 2024"
      },
      created_at: "2023-11-20T10:15:33.456Z",
      updated_at: "2024-04-15T09:22:18.789Z"
    },
    {
      id: "loreal-paris",
      _id: "6662b9e1cf9a0d6d79c78cbf",
      brand_name: "L'Oréal Paris",
      client_id: "999999-ffff-44444-9999-d951111c13f0",
      archived: !1,
      origin_id: "66621e9dd077d60f67579694",
      version: 7,
      config: {
        content_config: {
          guidelines: ["Emphasize the luxury and science behind products", "Highlight the Parisian heritage", "Focus on empowerment and self-worth"],
          guidelines_shortener: ["Maintain the premium positioning", "Keep references to Paris when possible", "Preserve empowerment messaging"],
          restrictions: ["Do not use slang terminology", "Avoid overly casual language", "Do not make claims about permanent results"],
          style_guide: {
            target_audience: "Women aged 25-55 who value quality and expertise",
            tone_of_voice: "Sophisticated, expert, and empowering"
          }
        }
      },
      brand_keywords: {
        priority: ["Paris", "Expertise", "Science"],
        required: ["Worth it", "Beauty", "Innovation"],
        optional: ["Luxury", "Premium", "Advanced"],
        omit: ["Cheap", "Simple", "Basic"],
        keyphrases_required: ["Because you're worth it", "The science of beauty"],
        keyphrases_optional: ["Paris expertise", "Advanced formulas"]
      },
      brand_language: [
        {
          region: "66def0bcf0180e94af9bc451",
          patterns: ["L'OREAL", "L'Oreal"],
          replacement: "L'Oréal Paris"
        }
      ],
      update_info: {
        type: "edit",
        from_version: 6,
        user_name: "Emma Thompson",
        comment: "Updated brand positioning for luxury markets"
      },
      created_at: "2023-11-20T10:20:45.123Z",
      updated_at: "2024-05-10T11:33:27.654Z"
    },
    {
      id: "garnier",
      _id: "6662b9e1cf9a0d6d79c78cc0",
      brand_name: "Garnier",
      client_id: "999999-ffff-44444-9999-d951111c13f0",
      archived: !1,
      origin_id: "66621e9dd077d60f67579695",
      version: 3,
      config: {
        content_config: {
          guidelines: [
            "Emphasize natural ingredients and sustainability",
            "Focus on the effectiveness of products",
            "Highlight eco-friendly initiatives"
          ],
          guidelines_shortener: ["Maintain references to natural ingredients", "Keep sustainability messaging", "Preserve key product benefits"],
          restrictions: [
            "Do not make claims about permanent results",
            "Avoid medical terminology",
            "Do not use technical jargon without explanation"
          ],
          style_guide: {
            target_audience: "Environmentally conscious consumers aged 18-45",
            tone_of_voice: "Natural, friendly, and environmentally aware"
          }
        }
      },
      brand_keywords: {
        priority: ["Natural", "Sustainable", "Eco-friendly"],
        required: ["Plant-based", "Green", "Effective"],
        optional: ["Recyclable", "Biodegradable", "Cruelty-free"],
        omit: ["Chemical", "Artificial", "Synthetic"],
        keyphrases_required: ["Naturally good", "Take care"],
        keyphrases_optional: ["Powered by nature", "Sustainable beauty"]
      },
      update_info: {
        type: "edit",
        from_version: 2,
        user_name: "David Wilson",
        comment: "Updated sustainability messaging"
      },
      created_at: "2023-11-20T10:25:18.789Z",
      updated_at: "2024-03-05T14:45:36.321Z"
    }
  ],
  regions: [
    {
      label: "United Kingdom (English)",
      locale: "uk_en"
    },
    {
      label: "France (French)",
      locale: "fr_fr"
    },
    {
      label: "Germany (German)",
      locale: "de_de"
    },
    {
      label: "United States (English)",
      locale: "us_en"
    },
    {
      label: "Canada (English)",
      locale: "ca_en"
    },
    {
      label: "Canada (French)",
      locale: "ca_fr"
    },
    {
      label: "Spain (Spanish)",
      locale: "es_es"
    },
    {
      label: "Italy (Italian)",
      locale: "it_it"
    }
  ]
}, o = {
  position: 0,
  item_count: 4,
  total_item_count: 14,
  jobs: [
    {
      _id: "660c07cf7082ac6d43f93db2",
      client_id: "loreal",
      brand_id: "maybelline_new_york",
      retailer_id: "30158870",
      region_id: "66b14f72371661d5156444f9",
      project_id: "66b14fbe134afa4b5dab2d5a",
      project_name: "STUB - The Default Project by Loreal",
      retailer_name: "STUB - Amazon (UK - English)",
      type: "standard_content",
      product_object_id: "66030b818a2527856a270b2a",
      product_id: "30158870",
      product_name: "STUB - Nagellack Gel Couture",
      reference_name: "STUB - Nail varnish top coat",
      group_id: "1000001",
      status: "processing",
      brandbrain_job_id: "1",
      created_at: "2024-04-25T06:09:58.997Z",
      updated_at: "2024-04-25T06:09:58.997Z",
      archived: !1
    },
    {
      _id: "660c07cf7082ac6d43f93db3",
      client_id: "loreal",
      brand_id: "maybelline_new_york",
      retailer_id: "30158870",
      region_id: "66b14f72371661d5156444f9",
      project_id: "66b14fbe134afa4b5dab2d5a",
      project_name: "STUB - The Default Project by Loreal",
      retailer_name: "STUB - Boots (UK - English)",
      type: "standard_content",
      product_object_id: "66030b818a2527856a270b2a",
      product_id: "30158870",
      product_name: "STUB - Nagellack Gel Couture",
      reference_name: "STUB - Nail varnish top coat",
      group_id: "1000001",
      status: "processing",
      brandbrain_job_id: "2",
      created_at: "2024-04-25T06:09:58.997Z",
      updated_at: "2024-04-25T06:09:58.997Z",
      archived: !1
    },
    {
      _id: "660c07cf7082ac6d43f93db7",
      client_id: "loreal",
      brand_id: "maybelline_new_york",
      retailer_id: "30158870",
      region_id: "66b14f72371661d5156444f9",
      project_id: "66b14fbe134afa4b5dab2d5a",
      project_name: "STUB - The Default Project by Loreal",
      retailer_name: "STUB - Douglas (DE - German)",
      type: "standard_content",
      product_object_id: "66030b818a2527856a270b2c",
      product_id: "30158875",
      product_name: "STUB - Other Nagellack Gel Couture",
      reference_name: "STUB - Other Nail varnish top coat",
      group_id: "1000003",
      status: "processing",
      brandbrain_job_id: "6",
      created_at: "2024-04-25T06:09:58.997Z",
      updated_at: "2024-04-25T06:09:58.997Z",
      archived: !1
    },
    {
      _id: "660c07cf7082ac6d43f93dba",
      client_id: "loreal",
      brand_id: "maybelline_new_york",
      retailer_id: "30158870",
      region_id: "66b14f72371661d5156444f9",
      project_id: "66b14fbe134afa4b5dab2d5a",
      project_name: "STUB - The Default Project by Loreal",
      retailer_name: "STUB - Amazon (CA - English)",
      type: "standard_content",
      product_object_id: "66030b818a2527856a270b2e",
      product_id: "30158876",
      product_name: "STUB - One More Nagellack Gel Couture",
      reference_name: "STUB - One More Nail varnish top coat",
      group_id: "1000004",
      status: "executing",
      brandbrain_job_id: "9",
      created_at: "2024-04-25T06:09:58.997Z",
      updated_at: "2024-04-25T06:09:58.997Z",
      archived: !1
    }
  ]
}, d = {
  _id: "666058d0a33bf6ae84944472",
  client_id: "loreal",
  brand_id: "essie",
  region_id: "66b14f72371661d5156444f9",
  project_id: "66b14fbe134afa4b5dab2d5a",
  project_name: "Spring Refresh 2024",
  retailer_id: "amazon_uk_en",
  retailer_name: "STUB - Amazon (UK - English)",
  type: "standard_content",
  group_id: "123",
  product_object_id: "6629f39e8cd19469251879cd",
  product_id: "123456",
  product_name: "STUB - Nagellack Gel Couture",
  reference_name: "STUB - Nagellack Gel Couture 2024 ABC",
  status: "completed",
  brandbrain_job_id: "68f3ad4c-afdc-4b15-a9a8-98eadba77445",
  approved_at: "2024-06-13T12:36:00.876Z",
  approved_by: "test_user",
  archived: !1,
  created_at: "2024-04-25T06:09:58.997Z",
  updated_at: "2024-04-25T06:09:58.997Z",
  content_items: [
    {
      _id: "6629f3b69a452d40b80d9c45",
      job_id: "6633b0435c038f9553009a78",
      type: "title",
      content: "STUB - My new project title",
      original_content: "STUB - My new project titles",
      edits: [
        {
          user_name: "STUB - Mike O'Loughlin",
          reason: "STUB - Title not new enough",
          timestamp: "2024-01-02T09:04:59.301Z"
        }
      ],
      warnings: {},
      updated_at: "2024-01-02T09:04:59.301Z",
      created_at: "2024-01-02T09:04:59.301Z"
    }
  ],
  client: {
    id: "loreal",
    client_name: "STUB - L'Oréal",
    approval_required: {
      regional_standard_generation: !0,
      retailer_adaption: !1,
      sku_adaption: !1
    },
    update_info: {
      user_name: "STUB - Mike O'Loughlin",
      comment: "STUB - Performing client request #CS-123"
    },
    archived: !1,
    created_at: "2024-01-01T08:02:59.301Z",
    updated_at: "2024-01-01T08:02:59.301Z"
  },
  brand: {
    _id: "6662b9e1cf9a0d6d79c78cbe",
    client_id: "loreal",
    brand_name: "STUB - Maybelline New York",
    version: 5,
    origin_id: "66621e9dd077d60f67579693",
    archived: !1,
    config: {
      content_config: {
        guidelines: ["STUB - Do not use any links."],
        guidelines_shortener: ["STUB - Keep the same tone and style."],
        restrictions: ["STUB - Do not mention any website links."],
        style_guide: {
          tone_of_voice: "STUB - Informative and persuasive",
          target_audience: "STUB - Women aged 18-50"
        }
      }
    },
    update_description: {
      updated_fields: {},
      removed_fields: ["string"],
      truncated_arrays: [
        {
          field: "string",
          new_size: 0
        }
      ]
    },
    update_info: {
      type: "edit",
      from_version: 2,
      user_name: "STUB - Mike O'Loughlin",
      comment: "STUB - Performing client request #CS-123"
    },
    created_at: "2024-01-01T08:02:59.301Z",
    updated_at: "2024-01-01T08:02:59.301Z"
  },
  retailer: {
    _id: "6667749c730537c75c2e3495",
    id: "6667749c730537c75c2e3495",
    type: "retailer",
    name: "STUB - Amazon (UK - English)",
    origin_id: "66b155610d4d56e987706694",
    version: 4,
    region: "66b156f86b6ef9b8b178cf8f",
    region_name: "STUB - United Kingdom (English)",
    archived: !1,
    config: {
      channel: "Amazon",
      content_config: {
        guidelines: ["STUB - * Do not use any links."],
        guidelines_shortener: ["STUB - * Keep the same tone and style."],
        restrictions: ["STUB - Do not mention any website links."]
      }
    },
    content_blocks: [
      {
        id: "title",
        title: "Title",
        position: 1,
        apply_style_guide: !1,
        family: "bullets",
        task: "Write a title containing the product name and type of product with no exclamation marks or quotes",
        character_limit: 120,
        guidelines: ["STUB - * Do not use any links."],
        guidelines_shortener: ["STUB - * Keep the same tone and style."],
        restrictions: ["STUB - Do not mention any website links."],
        additions: "string",
        keyword_groups: {
          should: ["STUB - optional"],
          must: ["STUB - required"],
          omit: ["STUB - omit"],
          verbatim_must_claims: ["STUB - keyphrases_required"],
          non_verbatim_optional_claims: ["STUB - keyphrases_optional"]
        }
      }
    ],
    brand_language: [
      {
        region: "66b156b2f5cc16a8cf4a748c",
        patterns: ["STUB - ESSIE"],
        replacement: "essie"
      }
    ],
    retailer_keywords: {
      priority: ["STUB - Biodegradable"],
      required: ["STUB - Compostable"],
      optional: ["STUB - Green"],
      omit: ["STUB - Shopping barrier"],
      keyphrases_required: ["STUB - Carbon Trust certified product"],
      keyphrases_optional: ["STUB - We are dedicated to our carbon neutrality goals"]
    },
    update_description: {
      updated_fields: {},
      removed_fields: ["string"],
      truncated_arrays: [
        {
          field: "string",
          new_size: 0
        }
      ]
    },
    update_info: {
      type: "edit",
      from_version: 2,
      user_name: "STUB - Mike O'Loughlin",
      comment: "STUB - Performing client request #CS-123"
    },
    created_at: "2024-01-01T08:02:59.301Z",
    updated_at: "2024-01-01T08:02:59.301Z"
  },
  config: {
    brand: {
      _id: "6662b9e1cf9a0d6d79c78cbe",
      client_id: "loreal",
      brand_name: "STUB - Maybelline New York",
      version: 5,
      origin_id: "66621e9dd077d60f67579693",
      archived: !1,
      config: {
        content_config: {
          guidelines: ["STUB - Do not use any links."],
          guidelines_shortener: ["STUB - Keep the same tone and style."],
          restrictions: ["STUB - Do not mention any website links."],
          style_guide: {
            tone_of_voice: "STUB - Informative and persuasive",
            target_audience: "STUB - Women aged 18-50"
          }
        }
      },
      update_description: {
        updated_fields: {},
        removed_fields: ["string"],
        truncated_arrays: [
          {
            field: "string",
            new_size: 0
          }
        ]
      },
      update_info: {
        type: "edit",
        from_version: 2,
        user_name: "STUB - Mike O'Loughlin",
        comment: "STUB - Performing client request #CS-123"
      },
      created_at: "2024-01-01T08:02:59.301Z",
      updated_at: "2024-01-01T08:02:59.301Z"
    },
    product: {
      _id: "66030b818a2527856a270b2a",
      project_id: "66b14fbe134afa4b5dab2d5a",
      region_id: "66b15443cfdc56237e340321",
      reference_name: "STUB - Nail varnish top coat",
      reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
      product_id: "30158870",
      keywords: {
        priority: ["STUB - Luxury"],
        required: ["STUB - Longlasting"],
        optional: ["STUB - Moisturising"],
        omit: ["STUB - Cheap"],
        keyphrases_required: ["STUB - Easy to use"],
        keyphrases_optional: ["STUB - Made with eco-friendly ingredients"]
      },
      attributes: [
        {
          name: "brand",
          value: "STUB - Maybelline New York"
        },
        {
          name: void 0,
          value: "STUB - Essie"
        },
        {
          name: "product_type",
          value: void 0
        },
        {
          name: void 0,
          value: void 0
        }
      ],
      created_at: "2024-01-02T09:04:59.301Z",
      updated_at: "2024-01-02T09:04:59.301Z"
    },
    retailer: {
      _id: "6667749c730537c75c2e3495",
      id: "6667749c730537c75c2e3495",
      type: "retailer",
      name: "STUB - Amazon (UK - English)",
      origin_id: "66b155610d4d56e987706694",
      version: 4,
      region: "66b156f86b6ef9b8b178cf8f",
      region_name: "STUB - United Kingdom (English)",
      archived: !1,
      config: {
        channel: "STUB - Amazon",
        content_config: {
          guidelines: ["STUB - * Do not use any links."],
          guidelines_shortener: ["STUB - * Keep the same tone and style."],
          restrictions: ["STUB - Do not mention any website links."]
        }
      },
      content_blocks: [
        {
          id: "title",
          title: "Title",
          position: 1,
          apply_style_guide: !1,
          family: "bullets",
          task: "STUB - Write a title containing the product name and type of product with no exclamation marks or quotes",
          character_limit: 120,
          guidelines: ["STUB - * Do not use any links."],
          guidelines_shortener: ["STUB - * Keep the same tone and style."],
          restrictions: ["STUB - Do not mention any website links."],
          additions: "string",
          keyword_groups: {
            should: ["STUB - optional"],
            must: ["STUB - required"],
            omit: ["STUB - omit"],
            verbatim_must_claims: ["STUB - keyphrases_required"],
            non_verbatim_optional_claims: ["STUB - keyphrases_optional"]
          }
        }
      ],
      brand_language: [
        {
          region: "66b156b2f5cc16a8cf4a748c",
          patterns: ["ESSIE"],
          replacement: "essie"
        }
      ],
      retailer_keywords: {
        priority: ["STUB - Biodegradable"],
        required: ["STUB - Compostable"],
        optional: ["STUB - Green"],
        omit: ["STUB - Shopping barrier"],
        keyphrases_required: ["STUB - Carbon Trust certified product"],
        keyphrases_optional: ["STUB - We are dedicated to our carbon neutrality goals"]
      },
      update_description: {
        updated_fields: {},
        removed_fields: ["string"],
        truncated_arrays: [
          {
            field: "string",
            new_size: 0
          }
        ]
      },
      update_info: {
        type: "edit",
        from_version: 2,
        user_name: "STUB - Mike O'Loughlin",
        comment: "STUB - Performing client request #CS-123"
      },
      created_at: "2024-01-01T08:02:59.301Z",
      updated_at: "2024-01-01T08:02:59.301Z"
    },
    standard_content_job_id: "66b15b56f7c6e692346c1734",
    retailer_adaption_job_id: "66b15b8b2fc728a156df7cf3"
  }
}, s = {
  _id: "6629f3b69a452d40b80d9c45",
  job_id: "6633b0435c038f9553009a78",
  type: "title",
  content: "MOCKED My new project title",
  original_content: "Mocked My old project title",
  edits: [
    {
      user_name: "MOCKED Mike O'Loughlin",
      reason: "MOCKED Title not new enough",
      timestamp: "2024-01-02T09:04:59.301Z"
    }
  ],
  warnings: {},
  updated_at: "2024-01-02T09:04:59.301Z",
  created_at: "2024-01-02T09:04:59.301Z"
}, c = {
  brand: "Maybelline New York",
  brand_id: "maybelline_new_york",
  client: "L'Oréal",
  client_id: "loreal",
  id: "660d2be5febf82385e93c335",
  project_name: "MOCK - Mock Project",
  regions: [
    {
      region_id: "66965e7a728e82dc7af09a7c",
      standard_retailer: "66965f4058f3afd1ba3ba145",
      retailers: ["amazon_uk_en"],
      uploads: [
        {
          file_name: "MOCK_file-test.xlsx",
          upload_id: "16f7e1f1-156a-4fff-9062-392f25d0f875"
        }
      ]
    }
  ]
}, l = {
  position: 0,
  item_count: 3,
  total_item_count: 15,
  projects: [
    {
      _id: "660c0b357082ac6d43f93deb",
      project_name: "Summer Collection 2024",
      client_id: "999999-ffff-44444-9999-d951111c13f0",
      brand_id: "maybelline_new_york",
      regions: [
        {
          region_code: "uk",
          retailers: ["amazon_uk_en", "boots_uk_en"],
          uploads: [
            {
              file_name: "UK_Summer_Collection_2024.xlsx",
              upload_id: "66d3a7c8e4f5b2a1c9d8e7f6"
            }
          ]
        },
        {
          region_code: "de",
          retailers: ["amazon_de_de", "dm_de_de"],
          uploads: [
            {
              file_name: "DE_Summer_Collection_2024.xlsx",
              upload_id: "66d3a7c8e4f5b2a1c9d8e7f7"
            }
          ]
        }
      ],
      created_at: "2024-03-15T10:23:45.789Z",
      updated_at: "2024-04-20T14:35:22.456Z",
      completed_at: "2024-04-20T14:35:22.456Z",
      __v: 2,
      schema_version: "1.0.0",
      job_count: 12,
      job_progress_count: 12,
      retailer_count: 4,
      region_count: 2,
      status: "completed",
      product_count: 6
    },
    {
      _id: "660c0b357082ac6d43f93dec",
      project_name: "Fall Essentials 2024",
      client_id: "888888-eeee-33333-8888-c84222d24e1",
      brand_id: "loreal_paris",
      regions: [
        {
          region_code: "us",
          retailers: ["target_us_en", "walmart_us_en", "ulta_us_en"],
          uploads: []
        },
        {
          region_code: "ca",
          retailers: ["amazon_ca_en", "shoppers_ca_en"],
          uploads: []
        }
      ],
      created_at: "2024-04-05T09:12:33.654Z",
      updated_at: "2024-05-10T16:45:12.321Z",
      completed_at: "",
      __v: 5,
      schema_version: "1.0.0",
      job_count: 20,
      job_progress_count: 15,
      retailer_count: 5,
      region_count: 2,
      status: "in_progress",
      product_count: 8
    },
    {
      _id: "660c0b357082ac6d43f93ded",
      project_name: "Holiday Collection 2024",
      client_id: "777777-dddd-22222-7777-b73333c35f2",
      brand_id: "nyx",
      regions: [
        {
          region_code: "fr",
          retailers: ["sephora_fr_fr", "monoprix_fr_fr"],
          uploads: []
        },
        {
          region_code: "it",
          retailers: ["sephora_it_it"],
          uploads: []
        },
        {
          region_code: "es",
          retailers: ["sephora_es_es", "elcorteingles_es_es"],
          uploads: []
        }
      ],
      created_at: "2024-05-20T11:30:45.987Z",
      updated_at: "2024-05-22T13:25:18.765Z",
      completed_at: "",
      __v: 1,
      schema_version: "1.0.0",
      job_count: 15,
      job_progress_count: 3,
      retailer_count: 5,
      region_count: 3,
      status: "ready_for_review",
      product_count: 5
    }
  ]
}, _ = {
  _id: "660c0b357082ac6d43f93deb",
  project_name: "Mock - My first project",
  client_id: "davidtestclient",
  brand_id: "davidtestbrand",
  regions: [
    {
      region_id: "66965e7a728e82dc7af09a7c",
      standard_retailer: "66965f4058f3afd1ba3ba145",
      retailers: ["66965ef71d5c3242cd851b9b"],
      uploads: [
        {
          file_name: "my_file.xlsx",
          upload_id: "769ad984-94b9-4cf1-bc9a-2b59c36facaa"
        }
      ]
    }
  ],
  status: "ready_for_review",
  archived: !1,
  created_at: "2024-01-01T08:02:59.301Z",
  updated_at: "2024-01-01T08:02:59.301Z",
  submitted_at: "2024-01-01T08:02:59.301Z",
  completed_at: "2024-01-01T08:02:59.301Z",
  update_info: {
    user_name: "Mock - Mathews Monoo"
  },
  counts: {
    all: {
      total: 800,
      completed: 500,
      pending_approval: 250
    },
    standard_content: {
      total: 400,
      completed: 200,
      pending_approval: 150
    },
    retailer_adaption: {
      total: 300,
      completed: 150,
      pending_approval: 100
    },
    sku_adaption: {
      total: 100,
      completed: 0,
      pending_approval: 0
    }
  }
}, u = {
  config: {
    internalReview: {
      enabled: !0,
      pdpCopyEditing: !1,
      taskResubmission: !1
    },
    settingsPage: {
      enabled: !0,
      brandsSetup: !0,
      clientsSetup: !0,
      regionsSetup: !0,
      retailersSetup: !0
    }
  },
  regions: [
    {
      _id: "6667749c730537c75c2e3490",
      name: "(MOCKED) DACH (German)",
      locale: "en_gb",
      flag: "de",
      standard_retailers: ["6667749c730537c75c2e3495"],
      retailers: ["6667749c730537c75c2e3491"],
      archived: !1,
      created_at: "2024-01-01T08:02:59.301Z",
      updated_at: "2024-01-01T08:02:59.301Z",
      update_info: {
        user_name: "(MOCKED) Mike O'Loughlin",
        comment: "(MOCKED) Performing client request #CS-123"
      }
    }
  ],
  retailers: [
    {
      _id: "6667749c730537c75c2e3491",
      id: "6667749c730537c75c2e3491",
      type: "retailer",
      name: "(MOCKED) Amazon (UK - English)",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3492",
      id: "6667749c730537c75c2e3492",
      type: "retailer",
      name: "(MOCKED) Amazon (UK - German)",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3493",
      id: "6667749c730537c75c2e3493",
      type: "retailer",
      name: "(MOCKED) Boots (UK - English)",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3494",
      id: "6667749c730537c75c2e3494",
      type: "retailer",
      name: "(MOCKED) Boots (UK - German)",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3495",
      id: "6667749c730537c75c2e3495",
      type: "standard",
      name: "(MOCKED) Standard Content 1",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3496",
      id: "6667749c730537c75c2e3496",
      type: "standard",
      name: "(MOCKED) Standard Content 2",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3497",
      id: "6667749c730537c75c2e3497",
      type: "standard",
      name: "(MOCKED) Category 1",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3498",
      id: "6667749c730537c75c2e3498",
      type: "standard",
      name: "(MOCKED) Category 2",
      archived: !1
    },
    {
      _id: "6667749c730537c75c2e3499",
      id: "6667749c730537c75c2e3499",
      type: "standard",
      name: "(MOCKED) Category 3",
      archived: !1
    }
  ]
}, p = {
  email_id: "MOCKED.testvml@vml.com",
  user_name: "MOCKED FirstName LastName",
  client_accounts: [
    {
      account_id: "2517b395-fae5-4012-9677-d9519ec1bf50",
      account_name: "MOCKED-Coca-cola",
      user_permissions: ["PDP_APP_POST_EVENTS_BY", "PDP_APP_POST_CLIENTS", "PDP_APP_GET_CONFIG"],
      user_roles: ["ProjectManager"]
    }
  ]
}, m = {
  _id: "66030b818a2527856a270b2a",
  project_id: "67236606a2b8ef5fc20b9dc1",
  project_region_id: "67288f14d451bf9853282a37",
  region_id: "66b15443cfdc56237e340321",
  reference_name: "Nail varnish top coat",
  reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
  product_id: "1000001",
  gpc_code: 10000123,
  status: "draft",
  keywords: {
    priority: ["Luxury"],
    required: ["Longlasting"],
    optional: ["Moisturising"],
    omit: ["Cheap"],
    keyphrases_required: ["Easy to use"],
    keyphrases_optional: ["Made with eco-friendly ingredients"],
    keyphrases_with_disclaimers: ["claim *"]
  },
  attributes: [
    {
      name: "brand",
      value: "Maybelline New York"
    }
  ],
  standard_content: [
    {
      content_type_id: "description",
      content: "This is some example content"
    },
    {
      content_type_id: "bullets",
      content: ["This is the first bullet"]
    }
  ],
  validation: {
    status: "complete"
  },
  created_at: "2024-01-02T09:04:59.301Z",
  updated_at: "2024-01-02T09:04:59.301Z",
  variants: [
    {
      _id: "66030b818a2527856a270b2a",
      project_region_id: "67288f14d451bf9853282a37",
      product_id: "1000001",
      variant_id: "1000001-001",
      reference_name: "Nail varnish top coat - Black",
      reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
      master: !1,
      keywords: {
        priority: ["Luxury"],
        required: ["Longlasting"],
        optional: ["Moisturising"],
        omit: ["Cheap"],
        keyphrases_required: ["Easy to use"],
        keyphrases_optional: ["Made with eco-friendly ingredients"],
        keyphrases_with_disclaimers: ["claim *"]
      },
      attributes: [
        {
          name: "brand",
          value: "Maybelline New York"
        }
      ],
      standard_content: [
        {
          content_type_id: "description",
          content: "This is some example content"
        },
        {
          content_type_id: "bullets",
          content: ["This is the first bullet"]
        }
      ],
      validation: {
        status: "complete"
      },
      created_at: "2024-01-02T09:04:59.301Z",
      updated_at: "2024-01-02T09:04:59.301Z"
    }
  ],
  region: {
    _id: "6667749c730537c75c2e3495",
    name: "DACH (German)",
    locale: "en_gb",
    flag: "de",
    standard_retailers: ["66677a49b796a625bb6f14ab"],
    retailers: ["66677acf37cf9a42511c1feb"],
    archived: !1,
    created_at: "2024-01-01T08:02:59.301Z",
    updated_at: "2024-01-01T08:02:59.301Z"
  }
}, f = {
  position: 50,
  item_count: 50,
  total_item_count: 1e3,
  products: [
    {
      _id: "66030b818a2527856a270b2a",
      project_id: "67236606a2b8ef5fc20b9dc1",
      project_region_id: "67288f14d451bf9853282a37",
      region_id: "66b15443cfdc56237e340321",
      reference_name: "Nail varnish top coat",
      reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
      product_id: "1000001",
      gpc_code: 10000123,
      status: "draft",
      keywords: {
        priority: ["Luxury"],
        required: ["Longlasting"],
        optional: ["Moisturising"],
        omit: ["Cheap"],
        keyphrases_required: ["Easy to use"],
        keyphrases_optional: ["Made with eco-friendly ingredients"],
        keyphrases_with_disclaimers: ["claim *"]
      },
      attributes: [
        {
          name: "brand",
          value: "Maybelline New York"
        }
      ],
      standard_content: [
        {
          content_type_id: "description",
          content: "This is some example content"
        },
        {
          content_type_id: "bullets",
          content: ["This is the first bullet"]
        }
      ],
      validation: {
        status: "complete"
      },
      created_at: "2024-01-02T09:04:59.301Z",
      updated_at: "2024-01-02T09:04:59.301Z",
      variants: [
        {
          _id: "66030b818a2527856a270b2a",
          project_region_id: "67288f14d451bf9853282a37",
          product_id: "1000001",
          variant_id: "1000001-001",
          reference_name: "Nail varnish top coat - Black",
          reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
          master: !1,
          keywords: {
            priority: ["Luxury"],
            required: ["Longlasting"],
            optional: ["Moisturising"],
            omit: ["Cheap"],
            keyphrases_required: ["Easy to use"],
            keyphrases_optional: ["Made with eco-friendly ingredients"],
            keyphrases_with_disclaimers: ["claim *"]
          },
          attributes: [
            {
              name: "brand",
              value: "Maybelline New York"
            }
          ],
          standard_content: [
            {
              content_type_id: "description",
              content: "This is some example content"
            },
            {
              content_type_id: "bullets",
              content: ["This is the first bullet"]
            }
          ],
          validation: {
            status: "complete"
          },
          created_at: "2024-01-02T09:04:59.301Z",
          updated_at: "2024-01-02T09:04:59.301Z"
        }
      ]
    }
  ]
}, g = {
  _id: "66030b818a2527856a270b2a",
  project_id: "67236606a2b8ef5fc20b9dc1",
  project_region_id: "67288f14d451bf9853282a37",
  region_id: "66b15443cfdc56237e340321",
  reference_name: "Nail varnish top coat",
  reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
  product_id: "1000001",
  gpc_code: 10000123,
  status: "draft",
  keywords: {
    priority: ["Luxury"],
    required: ["Longlasting"],
    optional: ["Moisturising"],
    omit: ["Cheap"],
    keyphrases_required: ["Easy to use"],
    keyphrases_optional: ["Made with eco-friendly ingredients"],
    keyphrases_with_disclaimers: ["claim *"]
  },
  attributes: [
    {
      name: "brand",
      value: "Maybelline New York"
    }
  ],
  standard_content: [
    {
      content_type_id: "description",
      content: "This is some example content"
    },
    {
      content_type_id: "bullets",
      content: ["This is the first bullet"]
    }
  ],
  validation: {
    status: "complete"
  },
  created_at: "2024-01-02T09:04:59.301Z",
  updated_at: "2024-01-02T09:04:59.301Z",
  variants: [
    {
      _id: "66030b818a2527856a270b2a",
      project_region_id: "67288f14d451bf9853282a37",
      product_id: "1000001",
      variant_id: "1000001-001",
      reference_name: "Nail varnish top coat - Black",
      reference_image_url: "https://www.essie.co.uk/-/media/Project/loreal/brand-sites/essie/EMEA/UK/collections/gel-couture-matte-top-coat/new/ESSIE-gel-couture-matte-top-coat-front-530.jpg",
      master: !1,
      keywords: {
        priority: ["Luxury"],
        required: ["Longlasting"],
        optional: ["Moisturising"],
        omit: ["Cheap"],
        keyphrases_required: ["Easy to use"],
        keyphrases_optional: ["Made with eco-friendly ingredients"],
        keyphrases_with_disclaimers: ["claim *"]
      },
      attributes: [
        {
          name: "brand",
          value: "Maybelline New York"
        }
      ],
      standard_content: [
        {
          content_type_id: "description",
          content: "This is some example content"
        },
        {
          content_type_id: "bullets",
          content: ["This is the first bullet"]
        }
      ],
      validation: {
        status: "complete"
      },
      created_at: "2024-01-02T09:04:59.301Z",
      updated_at: "2024-01-02T09:04:59.301Z"
    }
  ],
  region: {
    _id: "6667749c730537c75c2e3495",
    name: "DACH (German)",
    locale: "en_gb",
    flag: "de",
    standard_retailers: ["66677a49b796a625bb6f14ab"],
    retailers: ["66677acf37cf9a42511c1feb"],
    archived: !1,
    created_at: "2024-01-01T08:02:59.301Z",
    updated_at: "2024-01-01T08:02:59.301Z"
  }
}, b = {
  _id: "67addf50864ce1349b8f68a7",
  project_region_id: "67addeb6c1affc749dcffbdd",
  product_id: "071444444444N1",
  variant_id: "071444444444N1V3",
  master: !1,
  reference_name: "P",
  reference_image_url: "https://m.media-amazon.com/images/I/61XFs00Zr2L._AC_SL1001_.jpg",
  attributes: [
    {
      name: "quantity",
      value: "32 x 100g"
    },
    {
      name: "size",
      value: "Adult"
    },
    {
      name: "colour",
      value: "colour3"
    },
    {
      name: "flavour",
      value: "9x Beef and liver mix, 6x Lamb and liver mix, 6x Chicken, 6x Poultry"
    },
    {
      name: "format",
      value: "pouch"
    },
    {
      name: "formulation",
      value: `Beef and Liver Mix Meat and Animal Derivatives^ (including a mix of Beef 6% and Pork Liver 9.6% in the Chunk**), Vegetable Protein Extracts, Cereals, Minerals, Derivatives of Vegetable Origin (including Dried Beet Pulp 0.5%), ^Of which 93% Natural, **Chunk typically 48% of the product Chicken Meat and Animal Derivatives^ (including Chicken 14% and Pork Liver 9% in the Chunk**), Vegetable Protein Extracts, Cereals, Minerals, Derivatives of Vegetable Origin (including Dried Beet Pulp 0.5%), ^Of which 93% Natural, **Chunk typically 48% of the product Lamb and Liver Mix Meat and Animal Derivatives^ (including a mix of Lamb 6% and Pork Liver 9% in the Chunk**), Vegetable Protein Extracts, Cereals, Minerals, Derivatives of Vegetable Origin (including Dried Beet Pulp 0.5%), ^Of which 93% Natural, **Chunk typically 48% of the product Poultry Meat and Animal Derivatives^ (including Poultry 14% and Pork Liver 9% in the Chunk**), Vegetable Protein Extracts, Cereals, Minerals, Derivatives of Vegetable Origin (including Dried Beet Pulp 0.5%), ^Of which 93% Natural, **Chunk typically 48% of the product
`
    },
    {
      name: "product_dimensions",
      value: "var prod dim3"
    }
  ],
  keywords: {
    priority: [],
    optional: [],
    required: [],
    omit: [],
    keyphrases_required: [],
    keyphrases_optional: [],
    keyphrases_with_disclaimers: []
  },
  standard_content: [],
  created_at: "2025-02-13T12:02:24.123Z",
  updated_at: "2025-02-13T12:02:24.160Z",
  validation: {
    status: "complete"
  }
}, h = {
  id: "revlon-colorstay",
  _id: "6662b9e1cf9a0d6d79c78cbe",
  archived: !1,
  brand_name: "Revlon ColorStay",
  client_id: "123456-abcd-7890-efgh-d951111c13f0",
  origin_id: "66621e9dd077d60f67579693",
  version: 3,
  config: {
    content_config: {
      guidelines: [
        "Always emphasize the 24-hour staying power of ColorStay products",
        "Highlight the transfer-proof and smudge-proof qualities",
        "Mention the wide range of shades available for all skin tones"
      ],
      guidelines_shortener: ["Keep the 24-hour claim in shortened content", "Prioritize shade range information over application techniques"],
      restrictions: [
        "Never compare to specific competitor brands",
        "Don't make claims about waterproof properties unless specifically for waterproof products",
        "Avoid using the term 'permanent'"
      ],
      style_guide: {
        target_audience: "Women aged 25-45 who lead busy lifestyles",
        tone_of_voice: "Confident, reliable, and professional"
      },
      word_map: {
        "long-lasting": "24-hour wear",
        makeup: "cosmetics"
      }
    }
  },
  brand_keywords: {
    keyphrases_optional: ["makeup that stays", "all day wear", "professional finish"],
    keyphrases_required: ["24-hour wear", "transfer-resistant"],
    omit: ["temporary", "short-lived", "fades quickly"],
    optional: ["comfortable", "lightweight", "buildable"],
    priority: ["long-lasting", "transfer-proof", "wide shade range"],
    required: ["ColorStay", "24-hour", "smudge-proof"]
  },
  brand_language: [
    {
      patterns: ["revlon colorstay", "Revlon ColorStay"],
      region: "66def0bcf0180e94af9bc451",
      replacement: "Revlon ColorStay™"
    },
    {
      patterns: ["24 hour", "24-hour", "24 hr"],
      region: "66def0bcf0180e94af9bc451",
      replacement: "24-hour"
    }
  ],
  update_info: {
    comment: "Updated brand guidelines and keywords per marketing team request",
    from_version: 2,
    type: "edit",
    user_name: "mock user"
  },
  version_history: [
    {
      _id: "6662b9e1cf9a0d6d79c78cbd",
      version: 1,
      update_info: {
        comment: "Initial brand creation",
        type: "create",
        user_name: void 0
      },
      update_description: {
        updated_fields: {
          brand_name: "Revlon ColorStay",
          "config.content_config.guidelines": ["Initial guideline set"]
        }
      },
      created_at: "2023-11-15T10:30:22.301Z",
      updated_at: "2023-11-15T10:30:22.301Z"
    },
    {
      _id: "6662b9e1cf9a0d6d79c78cbe",
      version: 2,
      update_info: {
        comment: "Added brand keywords and language patterns",
        from_version: 1,
        type: "edit",
        user_name: "mock user"
      },
      update_description: {
        updated_fields: {
          brand_keywords: {
            required: ["ColorStay", "24-hour"]
          },
          brand_language: [
            {
              patterns: ["revlon colorstay"],
              replacement: "Revlon ColorStay™"
            }
          ]
        }
      },
      created_at: "2024-01-10T14:22:45.301Z",
      updated_at: "2024-01-10T14:22:45.301Z"
    }
  ],
  metadata: {
    job_count: 87,
    project_count: 6
  },
  created_at: "2023-11-15T10:30:22.301Z",
  updated_at: "2024-03-22T09:15:33.301Z"
}, y = {
  position: 0,
  item_count: 1,
  total_item_count: 1,
  items: [
    {
      _id: "67d94e50c67580db5a8c256e",
      project_id: "67d94e1a7511f90725733cc1",
      project_region_id: "67d94e3081fe73b70f660be2",
      region_id: "671f73e0f920d4ee3986419e",
      region_name: "United Kingdom",
      region_flag: "au-wa",
      region_locale: "gb_en",
      bucket: "cs-user-upload-product-bucket-dev",
      upload_key: "67d94e1a7511f90725733cc1/uploads/1742294607008-pdp_generator_product.xlsx",
      file_name: "mock_pdp_generator_product.xlsx",
      import_profile: "pdpg-excel-template",
      status: "completed",
      import_errors: [],
      update_info: {
        user_name: "Mock John Doe"
      },
      created_at: "2025-03-18T10:43:28.488Z",
      updated_at: "2025-03-18T10:43:33.422Z"
    }
  ]
}, v = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  a as JobType,
  t as configKeys,
  i as featureFlagsKeys,
  y as mockImportsList,
  g as mockProductData,
  b as mockVariantData,
  n as mockedClient,
  r as mockedClientsList,
  u as mockedConfig,
  o as mockedJobList,
  s as mockedPatchContentTypeSuccess,
  p as mockedPermissions,
  m as mockedProductDetail,
  f as mockedProductList,
  c as projectCreateSuccessResponse,
  l as projectsPreviewMock,
  d as singleJobResponseSuccess,
  _ as singleProjectMock,
  v as v5,
  h as versionBrandMock
};
